import React from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { SignInButton } from "../login";

import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useLoginRequest } from "utils/helpers/auth";

interface AuthPageProps {
  enabled?: boolean;
  children: React.ReactNode;
}

export const AuthPage: React.FC<AuthPageProps> = ({ enabled = true, children }) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <>
      <AutoLogin />
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div>You must be logged in to view this page.</div>
        <SignInButton />
      </UnauthenticatedTemplate>
    </>
  );
};

const AutoLogin: React.FC = () => {
  const loginRequest = useLoginRequest();
  const loginResult = useMsalAuthentication(InteractionType.Redirect, loginRequest);

  if (loginResult.error) {
    console.error("loginResult", loginResult);
  }

  return null;
};
